import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import Popover from '../core/Popover'; // http://dev.sankuai.com/code/repo-detail/~LIUWEI83/react-color/file/list?codeArea=bj

import { SketchPicker } from '@roo/react-color';
import { isFunction } from '@utiljs/is';
var defaultStyle = {
  width: '36px',
  height: '36px',
  border: '1px solid #efefef',
  borderRadius: '2px'
};
var defaultColor = '#f89800';

var DefaultColorPicker = function DefaultColorPicker(props) {
  return /*#__PURE__*/React.createElement(SketchPicker, _Object$assign({}, props));
};

var ColorPicker = /*#__PURE__*/function (_React$Component) {
  _inherits(ColorPicker, _React$Component);

  var _super = _createSuper(ColorPicker);

  function ColorPicker() {
    var _this;

    _classCallCheck(this, ColorPicker);

    _this = _super.apply(this, arguments); // eslint-disable-next-line

    _this.state = {
      color: _this.props.defaultValue || defaultColor
    };

    _this.rgba = function (color) {
      return "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a || 1, ")");
    };

    _this.handleChange = function (e) {
      if (_this.isControlled) {
        _this.handlePC(_this.rgba(e.rgb), e);
      } else {
        _this.handleColor(e);

        _this.handlePC(_this.rgba(e.rgb), e);
      }
    };

    _this.handlePC = function (a, b) {
      if (isFunction(_this.props.onChange)) {
        _this.props.onChange(a, b);
      }
    };

    _this.handleColor = function (e) {
      _this.setState({
        color: e
      });
    };

    return _this;
  }

  _createClass(ColorPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          presetColors = _this$props.presetColors,
          defaultVisible = _this$props.defaultVisible,
          visible = _this$props.visible,
          children = _this$props.children,
          className = _this$props.className,
          popupClassName = _this$props.popupClassName,
          trigger = _this$props.trigger,
          placement = _this$props.placement,
          disabled = _this$props.disabled,
          popupContainer = _this$props.popupContainer,
          onVisibleChange = _this$props.onVisibleChange,
          disableAlpha = _this$props.disableAlpha;
      var color = typeof this.state.color === 'string' ? this.state.color : this.state.color.rgb;

      var ss = _Object$assign(_Object$assign({}, defaultStyle), {
        background: typeof color === 'string' ? color : this.rgba(color)
      });

      return /*#__PURE__*/React.createElement(Popover, {
        defaultVisible: defaultVisible,
        visible: visible,
        placement: placement,
        trigger: trigger,
        useClone: true,
        lazy: true,
        flip: "flip",
        onVisibleChange: onVisibleChange,
        container: popupContainer,
        disabled: disabled,
        content: /*#__PURE__*/React.createElement("div", {
          className: "roo-color-picker-wrap"
        }, /*#__PURE__*/React.createElement(SketchPicker, {
          className: popupClassName,
          color: color,
          disableAlpha: disableAlpha,
          onChange: this.handleChange,
          presetColors: presetColors
        }))
      }, isFunction(children) ? children(this.state.color) : /*#__PURE__*/React.createElement("div", {
        className: "roo-color-picker-display ".concat(className),
        style: ss
      }));
    }
  }, {
    key: "isControlled",
    get: function get() {
      return this.props.value !== undefined && this.props.value !== null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, preState) {
      var value = nextProps.value;

      if (value !== undefined && value !== preState.color) {
        return {
          color: nextProps.value
        };
      }

      return null;
    }
  }]);

  return ColorPicker;
}(React.Component);

ColorPicker.ColorPanel = DefaultColorPicker;
ColorPicker.propTypes = {
  onChange: PropTypes.func,
  // onChangeComplete: PropTypes.func,
  presetColors: PropTypes.array,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  trigger: PropTypes.string,
  visible: PropTypes.bool,
  defaultVisible: PropTypes.bool,
  disableAlpha: PropTypes.bool,
  disabled: PropTypes.bool,
  placement: PropTypes.string,
  onVisibleChange: PropTypes.func,
  popupContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func])
};
ColorPicker.defaultProps = {
  onChange: function onChange() {},
  // onChangeComplete: () => {},
  presetColors: [],
  defaultVisible: false,
  disableAlpha: false,
  visible: undefined,
  value: undefined,
  className: '',
  trigger: 'click',
  disabled: false,
  placement: 'bottomLeft',
  defaultValue: defaultColor,
  popupContainer: undefined,
  onVisibleChange: undefined
};
export default ColorPicker;